module.exports = __webpack_public_path__ + "img/gb27.prt.dd5b68c8.jpg";